// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const obelisk = defineModel({
  id: "obelisk",
  batchId: "future",
  name: "Obelisk",
  tags: ["scenery","obelisk","low-poly","age-of-mcp","future"],
  summary: "A tall stone obelisk — a monument and landmark.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.28,
  parts: () => [
      { geometry: new THREE.BoxGeometry(0.34, 0.08, 0.34), color: "#6c655b", position: [0, 0.04, 0] },
      { geometry: new THREE.BoxGeometry(0.26, 0.08, 0.26), color: "#7a7060", position: [0, 0.12, 0] },
      { geometry: new THREE.CylinderGeometry(0.06, 0.11, 1, 4), color: "#9a8f7e", position: [0, 0.66, 0], rotation: [0, 0.785398, 0] },
      { geometry: new THREE.BoxGeometry(0.005, 0.9, 0.02), color: "#7a7060", position: [0.075, 0.62, 0] },
      { geometry: new THREE.ConeGeometry(0.085, 0.18, 4), color: "#7a7060", position: [0, 1.25, 0], rotation: [0, 0.785398, 0] },
      { geometry: new THREE.ConeGeometry(0.04, 0.08, 4), color: "#d8b24a", position: [0, 1.36, 0], rotation: [0, 0.785398, 0] },
    ],
  animations: [],
});
